import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../api/client';
import { isPortalNavigation } from '../utils/portalNavigation';

export function usePortalNavigationState() {
  const { user, vendor, isAuthenticated } = useAuth();
  return useQuery({ queryKey: ['portal-navigation', user?.id],
    // Login may succeed while its optional full-profile read fails.
    enabled: isAuthenticated && !!user?.id,
    queryFn: async () => {
      const value: unknown = (await apiClient.get('/vendor/profile/navigation')).data.data;
      if (!isPortalNavigation(value)) throw new Error('portal_navigation_unavailable');
      return value;
    },
    initialData: vendor?.id === user?.id && isPortalNavigation(vendor?.portal_navigation)
      ? vendor.portal_navigation : undefined,
    staleTime: 0,
    retry: false,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}

export function usePortalNavigation() {
  const query = usePortalNavigationState();
  return query.isError ? undefined : query.data;
}
